import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { StateStatus } from '../../enums/StateStatus';

export enum UserRoleType {
  SystemAdmin = 'SystemAdmin',
  ProjectAdmin = 'ProjectAdmin',
  ProjectParticipant = 'ProjectParticipant',
  Subcontractor = 'Subcontractor',
  ReadAll = 'ReadAll',
  SystemUser = 'SystemUser'
}

export enum RoleType {
  SystemRole,
  ProjectRole
}

export interface UserRole {
  id: number;
  name: UserRoleType;
  description: string;
  projectUserRoles: [];
  systemUserRoles: [];
}

export interface UserInfo {
  userRole: UserRole[];
  projectID: number;
  lang: string;
  profilePhoto: string;
  userID: number;
}

export interface UserState {
  userInfo: UserInfo | null;
  status: StateStatus;
  error: RestErrorResponse | null;
}
